// Azura — Schnellansicht/Quick-Add-Popup. Lädt sections/quick-add.liquid per
// Fetch nach und nutzt die vorhandene ModalDialog-Basis (global.js) für
// Öffnen/Schließen, Fokus-Trap und Escape/Klick-außerhalb.
if (!customElements.get('quick-add-modal') && customElements.get('modal-dialog')) {
  const ModalDialogBase = customElements.get('modal-dialog');

  class QuickAddModal extends ModalDialogBase {
    constructor() {
      super();
      this.contentContainer = this.querySelector('[id^="QuickAddInfo-"]');
    }

    show(opener) {
      this.openedBy = opener;
      const productUrl = opener?.getAttribute('data-product-url');
      document.body.classList.add('overflow-hidden');
      this.setAttribute('open', '');
      window.pauseAllMedia && window.pauseAllMedia();

      if (!productUrl || !this.contentContainer) return;

      this.contentContainer.classList.add('azura-quick-add--loading');

      fetch(`${productUrl}?section_id=quick-add`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const source = html.getElementById(this.contentContainer.id);
          if (source) this.contentContainer.innerHTML = source.innerHTML;
          this.contentContainer.classList.remove('azura-quick-add--loading');
          this.bindSizeSelection();
          trapFocus(this, this.querySelector('[role="dialog"]'));
        })
        .catch((e) => {
          console.error(e);
          this.contentContainer.classList.remove('azura-quick-add--loading');
        });
    }

    bindSizeSelection() {
      const list = this.querySelector('[data-quick-add-sizes]');
      if (!list) return;
      list.addEventListener('change', (event) => {
        if (event.target.name !== 'id') return;
        list.querySelectorAll('.azura-quick-add__size').forEach((label) => {
          label.classList.remove('is-checked');
        });
        event.target.closest('.azura-quick-add__size')?.classList.add('is-checked');
      });
    }
  }

  customElements.define('quick-add-modal', QuickAddModal);
}
